export default () => ({
  stocks: {},
  userInfo: {},
  cart: {},
  conversionInfo: {},
  txs: {},
  stores: {},
  extensionHeight: "100px",
  settings: {},
  currencies: [],
  displayCurrency: {},
  marketInfo: {},
  allStocks: [],
  cryptoWalletStep: 1,
  isLogin: Boolean,
  stockExchanges: {},
  selectedExchange: {},
  bankAccount: {},
  tab: "",
  socketResponse: {},
  isLoginWithoutEmail: false,
  isIframeOpenEmitted: false,
  sessionNotifyStatus: { active: false },
  hostedPageId: "",
  resultPageData: {
    icon: "",
    title: "",
    description: ""
  },
  showFeedback: false,
  refrenceId: null,
});
